import * as React from 'react';
import * as THREE from "three";
import { Text, View } from '../components/Themed';
import { ActivityIndicator, StyleSheet } from 'react-native';
import { AvatarSDKFileLoader, AvatarSDKTextureLoader, AvatarSDKGeometryLoader } from '../utils/samples_threejs_loaders';
import { useFocusEffect } from '@react-navigation/native';
import Container from './Container';
import Separator from './Separator';
import Email from './Email';
import { OrbitControls } from '../utils/OrbitControls';
import { PLAYER_UID } from '@env';

var camera: any, scene: any, renderer: any;
var base_geometry: any = null;
var mesh: any = null;
var texture: any = null;
var controls: any = null;

function animate() {
    requestAnimationFrame(animate);

    if (controls) {
        controls.update();
    }

    if (renderer) {
        renderer.render(scene, camera);
    }
}

function check_display_model() {
    let all_done = (!!base_geometry) && (!!texture);
    if (!all_done) return;

    base_geometry.computeBoundingBox();
    
    let modelHeight = base_geometry.boundingBox.getSize(new THREE.Vector3()).y;
    if (modelHeight < 30) {
      let factor = 30 / modelHeight;
      base_geometry.scale(factor, factor, factor);
    }

    let materialArgs = {
      color: 0xffffff,
      side: THREE.DoubleSide,
      morphTargets: true,
      map: texture
    };

    let material = new THREE.MeshBasicMaterial(materialArgs);
    mesh = new THREE.Mesh(base_geometry, material);
    console.log(mesh);
    
    scene.add(mesh);

    updateCameraPosition();
}

function updateCameraPosition() {
    if (!mesh) return;

    if (!mesh.geometry.boundingSphere) {
        mesh.geometry.computeBoundingSphere();
    }

    let target = mesh.geometry.boundingSphere.center;
    let modelHeight = mesh.geometry.boundingSphere.radius*2;
    let desiredheight = modelHeight * 1.1;
    let distance = desiredheight / (2 * Math.tan(degToRad(35/2))) +
        mesh.geometry.boundingSphere.center.z +
        mesh.geometry.boundingSphere.radius;
        
    let position = new THREE.Vector3(target.x, target.y, distance);    

    camera.position.copy(position);
    camera.lookAt(target);
    controls.update();
}

function onWindowResize() {
    var canvasContainer: any = document.querySelector('#canvas_container');
    var width = canvasContainer.offsetWidth;
    var height = canvasContainer.offsetHeight;

    camera.aspect = width / height;
    camera.updateProjectionMatrix();

    renderer.setSize( width, height );

    updateCameraPosition();
  }

function degToRad(degrees: any) {
    return degrees * Math.PI / 180;
}

export default function AvatarViewer({ resp, navigation }) {
    const [Loaded, setLoaded] = React.useState(false);
    var canceled: boolean = false;

    useFocusEffect(
        React.useCallback(() => {
            init(resp);
            animate();
        }, [resp])
    );

    React.useEffect(() => {
        navigation.addListener('blur', () => {
            canceled = true;
        });
    }, [navigation]);

    function init(resp: any) {
        var fileLoader = new AvatarSDKFileLoader(resp.token, PLAYER_UID);
        new AvatarSDKTextureLoader(fileLoader).load(resp.texture, (img: any) => {
            if (canceled) return;
            texture = img;
        }, null, null);
      
        new AvatarSDKGeometryLoader(fileLoader).load(resp.mesh, 'model.ply', (geometry: any) => {
            if (canceled) return;
            setLoaded(true);
    
            base_geometry = geometry;
            var canvasContainer: any = document.querySelector('#canvas_container');
            camera = new THREE.PerspectiveCamera(25, canvasContainer.offsetWidth / canvasContainer.offsetHeight, 1, 1000 );
            camera.position.z = 4;
            
            scene = new THREE.Scene();
            renderer = new THREE.WebGLRenderer( { antialias: true } );
            renderer.setPixelRatio( window.devicePixelRatio );
            renderer.setSize( canvasContainer.offsetWidth, canvasContainer.offsetHeight );
            renderer.setClearColor(new THREE.Color(0xcccccc));
            canvasContainer.appendChild( renderer.domElement );

            // Setup the orbit controls
            controls = new OrbitControls(camera, renderer.domElement);
            controls.panSpeed = 0.8;
            controls.minDistance = 10;
            controls.maxDistance = 100;

            check_display_model();
    
        }, null, null);
    
        window.addEventListener( 'resize', onWindowResize, false );
    }

    return (
        <>
            <View style={{ display: Loaded ? 'none' : undefined }}>
                <Text style={styles.text}>Création / Creating</Text>
                <ActivityIndicator size="large" />
            </View>
            {Loaded &&
            <Container>
                <div id="canvas_container" style={divStyle.container}>
                </div>
                <Text style={styles.text}>
                    CODE: {resp.name}
                </Text>
                <Separator />
            <Email code={resp.name} />
            </Container>}
        </>
    );
}

const styles = StyleSheet.create({
    text: {
        fontSize: 17,
        lineHeight: 24,
        margin: 10,
        color: 'rgba(0,0,0,0.8)'
      }
});

const divStyle = {
    container: {
        marginTop: 20,
        width: "100%",
        height: "50%",
    },
}
